import { membersBaseURL, clearObject } from "@/functions/helpers";

const baseURL = membersBaseURL();

const _post = (url, params, config = {}) =>
  window.axios.post(url, params, { baseURL, ...config });
const _put = (url, params) => window.axios.put(url, params, { baseURL });
const _delete = url => window.axios.delete(url, { baseURL });
const _get = url => window.axios.get(url, { baseURL });

export default {
  getAll(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return _get(`/courses/groups/list/${params.product_id}?${queryString}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setGroups", results);
          context.commit("setPagination", { count, next, previous });
          resolve({ data: { results, count, next, previous } });
        })
        .catch(reject);
    });
  },
  getGroupsFilter(context, { product_id, offers_id, plans_id }) {
    return new Promise((resolve, reject) => {
      const param = new URLSearchParams(
        clearObject({ offers_id, plans_id, limit: 999 })
      ).toString();
      return _get(`/courses/groups/filter/${product_id}?${param}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setGroupsfilter", results);
          context.commit("setPagination", { count, next, previous });
          resolve({ data: { results, count, next, previous } });
        })
        .catch(reject);
    });
  },

  getDetails(context, id) {
    return new Promise((resolve, reject) => {
      _get(`/courses/groups/${id}`)
        .then(({ data }) => {
          context.commit("setGroup", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  post(context, params) {
    return new Promise((resolve, reject) => {
      _post("/courses/groups", params)
        .then(resolve)
        .catch(reject);
    });
  },
  put(context, params) {
    return new Promise((resolve, reject) => {
      _put(`/courses/groups/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  delete(context, id) {
    return new Promise((resolve, reject) => {
      _delete(`/courses/groups/${id}`)
        .then(resolve)
        .catch(reject);
    });
  }
};
